import useUsers from "@/hooks/useUsers";
import type { CroFeature } from "@/types/croFeature";
import { userIsCROAdmin } from "@/util";

export type CroFeatureAccessLevel = "none" | "read" | "write";

export type UseHasRBACAccessToCROFeatureResult = {
  level: CroFeatureAccessLevel;
  loading: boolean;
};

// TODO(CE-1016): swap this stub for the real per-feature CRO RBAC check.
// Until then access mirrors userIsCROAdmin (see util.ts) so non-admin
// teammates land on the NoPermissionsPage rather than slipping through to
// the live feature view.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function useHasRBACAccessToCROFeature(
  _feature: CroFeature,
): UseHasRBACAccessToCROFeatureResult {
  const usersState = useUsers();
  return {
    level: userIsCROAdmin(usersState.currentUser) ? "write" : "none",
    loading: false,
  };
}
